import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SubmissionsService } from 'src/app/services/submissions.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-manipulation-type-frequency',
    templateUrl: './manipulation-type-frequency.component.html',
    styleUrls: ['./manipulation-type-frequency.component.scss']
})
export class ManipulationTypeFrequencyComponent implements OnInit, OnChanges {
    @Input() isProfessor: boolean = false;
    @Input() filterType: string;
    constructor(
        private submissionsService: SubmissionsService,
        private translate: TranslateService
    ) { }
    years: number[] = [];
    selectedYear: number;
    series = [{
        name: 'Frequency',
        data: [86, 42, 15]
    }];
    chart = {
        type: 'bar',
        height: 500,
        width: "100%"
    };
    xaxis = { categories: [] };
    yaxis = { min: 0, max: 100, tickAmount: 5 };
    plotOptions = { bar: { columnWidth: '60%', borderRadius: 6 } };
    dataLabels = { enabled: true, style: { fontSize: '1rem', fontWeight: 600 } };
    colors = ['#0059B2'];
    ngOnInit() {
        const currentYear = new Date().getFullYear();
        this.years = Array.from({ length: 5 }, (_, i) => currentYear - i).reverse();
        this.selectedYear = currentYear;

        this.fetchManipulationData(this.selectedYear);
        this.translate.get([
            'new_entries.character_replacement',
            'new_entries.hidden_text',
            'new_entries.image_in_place_of_text'
        ]).subscribe(translations => {
            this.xaxis = {
                categories: [
                    translations['new_entries.character_replacement'],
                    translations['new_entries.hidden_text'],
                    translations['new_entries.image_in_place_of_text']
                ]
            };
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['filterType'] && !changes['filterType'].firstChange) {
            this.fetchManipulationData(this.selectedYear);
        }
    }

    fetchManipulationData(year: number) {
        this.submissionsService.getManipulationSubmissions(year.toString(), this.isProfessor, undefined, undefined, undefined, this.filterType).subscribe(
            response => {
                console.log('Manipulation Data:', response);

                const characterReplacements = response.characterReplacements || 0;
                const hiddenText = response.hiddenText || 0;
                const imageAsText = response.imageAsText || 0;

                this.series = [{
                    name: this.translate.instant('new_entries.frequency'),
                    data: [characterReplacements, hiddenText, imageAsText]
                }];
            },
            error => {
                console.error('Failed to fetch manipulation statistics:', error);
            }
        );
    }

    onYearChange() {
        this.fetchManipulationData(this.selectedYear);
    }


} 